import React from "react";
import ReactDOM from 'react-dom/client';
import "./index.css";
import App from "./App";
import "./bootstrap.min.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// import 'bootstrap/dist/css/bootstrap.min.css';


ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);